/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Correspondence = {

	delete (context, templateId, onSuccess, onError, options) {
		Api.delete(context,
			"/correspondence"
			+ "?templateId=" + templateId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestTemplates (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/correspondence/contest-templates"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDownload (context, templateId, onSuccess, onError, options) {
		Api.get(context,
			"/correspondence/download"
			+ "?templateId=" + templateId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGenerate (context, projectId, templateId, onSuccess, onError, options) {
		Api.get(context,
			"/correspondence/generate"
			+ "?projectId=" + projectId
			+ "&templateId=" + templateId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGenerateWritings (context, contestId, templateId, offerStatusList, isHidden, isNotHidden, isArchived, isNotArchived, isAwaitingAnnexSigning, isNotAwaitingAnnexSigning, onSuccess, onError, options) {
		Api.get(context,
			"/correspondence/generate-writings"
			+ "?contestId=" + contestId
			+ "&templateId=" + templateId
			+ "&offerStatusList=" + offerStatusList
			+ "&isHidden=" + isHidden
			+ "&isNotHidden=" + isNotHidden
			+ "&isArchived=" + isArchived
			+ "&isNotArchived=" + isNotArchived
			+ "&isAwaitingAnnexSigning=" + isAwaitingAnnexSigning
			+ "&isNotAwaitingAnnexSigning=" + isNotAwaitingAnnexSigning
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, departmentId, onSuccess, onError, options) {
		Api.get(context,
			"/correspondence/list"
			+ "?departmentId=" + departmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, file, departmentId, onSuccess, onError, options) {
		Api.post(context,
			"/correspondence"
			+ "?file=" + file
			+ "&departmentId=" + departmentId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
